import url from './url';



export default url(({ taskId }) => `/tasks/${taskId}/tester`);
